/**
 * Plain-words lines for the D0 paper record (research/spx_1000am/FORWARD_D0.md; backend/paper_d0.py).
 * Pure functions, so the wording is tested without rendering the panel.
 */
const isNum = (v) => v !== null && v !== undefined && !Number.isNaN(Number(v));
const signedUsd = (v) => `${Number(v) >= 0 ? "+" : "−"}$${Math.abs(Number(v)).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const usd0 = (v) => `$${Math.abs(Number(v)).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
const pct = (v, d = 1) => `${(Number(v) * 100).toFixed(d)}%`;

export function spreadName(side) {
  return side === "call" ? "bear call" : "bull put";
}

/** One sentence: what D0 decided for the session, or why it did not trade. */
export function d0Decision(t) {
  if (!t) return "No D0 decision yet for this session. It is made at the 10:01 capture.";
  if (t.status === "no trade") return `No trade: ${t.reason}.`;
  if (t.status === "no data") return `No data: ${t.reason}.`;
  if (!isNum(t.credit)) return "D0 has not decided yet.";
  const strikes = `${t.short}/${t.long}`;
  const away = isNum(t.distance) ? ` (${pct(Math.abs(t.distance), 2)} from the 10:00 level)` : "";
  const sold = `D0 sold the ${strikes} ${spreadName(t.side)}${away} for ${Number(t.credit).toFixed(2)} points`;
  const why = isNum(t.err) ? `, expecting ${pct(t.err)} on its maximum loss of ${usd0(t.max_loss)}` : "";
  return `${sold}${why}.`;
}

/** One sentence: how the trade ended, once settled. */
export function d0Outcome(t) {
  if (!t || t.status !== "settled") return null;
  const beyond = t.side === "call" ? "above" : "below";
  const touch = t.touch_short_minute
    ? (t.settled_itm ? `The index touched the ${t.short} strike and settled ${beyond} it.` : `The index touched the ${t.short} strike, then recovered.`)
    : `The index never touched the ${t.short} strike.`;
  return `${touch} Net ${signedUsd(t.net)} for one spread.`;
}
